import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useEffect } from "react";

//Components
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';

//Actions
import {
    clearRedux,
    syncCTCInformationRequest
} from 'Redux/actions';

const SyncCTCInformation = (props) => {
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const {
        openModal,
        loading,
        result,
    } = useSelector(state => state.syncCTCInformationRedux);

    const handleSyncInfo = () => {
        dispatch(syncCTCInformationRequest())
    }

    const closeModal = () => {
        dispatch(clearRedux("SYNC_CTC_INFORMATION"))
    }

    useEffect(() => {
        if (result) {
            if (result?.stepFunctionId) {
                NotificationManager.success(
                    messages['sync_ctc_info_success_message'],
                    messages['sync_ctc_info_title'],
                    3000
                );
                closeModal();
            }
            else {
                NotificationManager.error(
                    messages['sync_ctc_info_error_message'],
                    messages['sync_ctc_info_title'],
                    3000
                );
                dispatch(clearRedux("SYNC_CTC_INFORMATION", { result: null }))
            }
        }
    }, [result])

    return (
        <Modal
            open={openModal}
            title={messages['sync_ctc_info_title']}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody>
                <div style={{ padding: '0 10px', height: 600 }}>
                    {messages['sync_ctc_info_description']}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={handleSyncInfo}
                >
                    {messages['sync_ctc_info_label']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default SyncCTCInformation;


